import { BalancesSummary } from './balances-summary.model';
import { BalancesDetails } from './balances-details.model';
import { BalancesConstants } from '../utils/balances-constants';
import { Entity } from './entity.model';
import { CoreConstants } from '@pershing/pershing-core';
import { AccountSummary } from './account-summary.model';

export class Balances {
    public asOfDate: string;
    public quoteType: string;
    constructor(
        public entity: Entity,
        public balancesSummary: BalancesSummary,
        public balancesDetails: BalancesDetails,
        public childBalances: Balances[],
        public accountSummary: AccountSummary,
        public custodian: Balances
    ) { }
}

export function defaultBalances(): Balances {
    return {
        custodian: defaultBalances(),
        entity: {
            id: undefined,
            name: undefined,
            context: CoreConstants.ACCOUNT,
            baseCurrency: undefined,
            custodianCode: undefined,
            accountCategory: undefined,
            accountType: undefined,
            quoteType: undefined
        },
        balancesSummary: {
            totalWorth: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            fundsAvailableToWithdraw: undefined,
            fundsAvailableToTrade: undefined,
            fundsDue: undefined
        },
        balancesDetails: {
            accountValue: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            longMarketValue: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            shortMarketValue: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            cashManagementBalance: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            openingBalance: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            todaysActivity: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            netBalance: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            totalAnnuityValue: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            securitiesOwed: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            liquidatingEquity: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            creditInterest: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            debitInterest: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            totalInsuranceValue: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            currentOpeningBalance: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            intraDayActivity: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            monthToDateEarnings: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            principalCash: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            incomeCash: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            cash: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            annuities: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            annuityFixedValAmt: undefined,
            annuityVariableValAmt: undefined,
            annuityPendingValAmt: undefined,
            overallCashAvailable: undefined,
            cashAvailableCash: undefined,
            cashAvailableMargin: undefined,
            cashManagementAvailable: undefined,
            pendingWithdrawals: undefined,
            overallCashAvailablePrincipal: undefined,
            cashAvailablePrincipal: undefined,
            cashManagementAvailablePrincipal: undefined,
            pendingWithdrawalsPrincipal: undefined,
            overallCashAvailableIncome: undefined,
            cashAvailableIncome: undefined,
            cashManagementAvailableIncome: undefined,
            pendingWithdrawalsIncome: undefined,
            fundsUnavailable: undefined,
            marginableEquity: undefined,
            nonMarginableEquity: undefined,
            longOptions: undefined,
            convertibleBonds: undefined,
            corporateBonds: undefined,
            municipalBonds: undefined,
            governmentBonds: undefined,
            dayTradingBuyingPower: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            dayTradeMarginableEquity: undefined,
            dayTradingBuyingPowerPrevClose: undefined,
            dayTradeNonMarginableEquity: undefined,
            dayTradeLongOptions: undefined,
            dayTradeConvertibleBonds: undefined,
            dayTradeCorporateBonds: undefined,
            dayTradeMunicipalBonds: undefined,
            dayTradeGovernmentBonds: undefined,
            prevSMA: undefined,
            taxReclaim: undefined,
            totalFederalCallSMA: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            smaChange: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            houseCall: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            finraCall: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            foreignCCYHouseReq: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            totalHouseReq: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            totalFinraReq: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            debitInterestRate: {
                value: undefined,
                difference: undefined,
                percentChange: undefined
            },
            optionHouseReq: undefined,
            securityHouseReq: undefined,
            cashAccountSurplusUsed: undefined,
            minimumEquityReq: undefined,
            whenIssuedHouseReq: undefined,
            foreignCCYList: undefined,
            usdeCurrencyDetailList: undefined,
            localCurrencyDetailList: undefined,
            currencyDetailList: undefined
        },
        childBalances: [],
        accountSummary: undefined,
        asOfDate: undefined,
        quoteType: undefined
    };
}
export function zeroBalances(): Balances {
    return {
        custodian: zeroBalances(),
        entity: {
            id: undefined,
            name: undefined,
            context: CoreConstants.ACCOUNT,
            baseCurrency: undefined,
            custodianCode: undefined,
            accountCategory: undefined,
            accountType: undefined,
            quoteType: undefined
        },
        balancesSummary: {
            totalWorth: BalancesConstants.zeroDataSet,
            fundsAvailableToWithdraw: BalancesConstants.zeroBalance,
            fundsAvailableToTrade: BalancesConstants.zeroBalance,
            fundsDue: BalancesConstants.zeroBalance
        },
        balancesDetails: {
            accountValue: BalancesConstants.zeroDataSet,
            longMarketValue: BalancesConstants.zeroDataSet,
            shortMarketValue: BalancesConstants.zeroDataSet,
            cashManagementBalance: BalancesConstants.zeroDataSet,
            openingBalance: BalancesConstants.zeroDataSet,
            todaysActivity: BalancesConstants.zeroDataSet,
            netBalance: BalancesConstants.zeroDataSet,
            totalAnnuityValue: BalancesConstants.zeroDataSet,
            totalInsuranceValue: BalancesConstants.zeroDataSet,
            securitiesOwed: BalancesConstants.zeroDataSet,
            liquidatingEquity: BalancesConstants.zeroDataSet,
            creditInterest: BalancesConstants.zeroDataSet,
            debitInterest: BalancesConstants.zeroDataSet,
            currentOpeningBalance: BalancesConstants.zeroDataSet,
            intraDayActivity: BalancesConstants.zeroDataSet,
            annuityFixedValAmt: BalancesConstants.zeroBalance,
            annuityVariableValAmt: BalancesConstants.zeroBalance,
            annuityPendingValAmt: BalancesConstants.zeroBalance,
            monthToDateEarnings: BalancesConstants.zeroDataSet,
            principalCash: BalancesConstants.zeroDataSet,
            incomeCash: BalancesConstants.zeroDataSet,
            overallCashAvailable: BalancesConstants.zeroBalance,
            cashAvailableCash: BalancesConstants.zeroBalance,
            cashAvailableMargin: BalancesConstants.zeroBalance,
            cashManagementAvailable: BalancesConstants.zeroBalance,
            pendingWithdrawals: BalancesConstants.zeroBalance,
            overallCashAvailablePrincipal: BalancesConstants.zeroBalance,
            cashAvailablePrincipal: BalancesConstants.zeroBalance,
            cashManagementAvailablePrincipal: BalancesConstants.zeroBalance,
            pendingWithdrawalsPrincipal: BalancesConstants.zeroBalance,
            overallCashAvailableIncome: BalancesConstants.zeroBalance,
            cashAvailableIncome: BalancesConstants.zeroBalance,
            cashManagementAvailableIncome: BalancesConstants.zeroBalance,
            pendingWithdrawalsIncome: BalancesConstants.zeroBalance,
            fundsUnavailable: BalancesConstants.zeroBalance,
            marginableEquity: BalancesConstants.zeroBalance,
            nonMarginableEquity: BalancesConstants.zeroBalance,
            longOptions: BalancesConstants.zeroBalance,
            convertibleBonds: BalancesConstants.zeroBalance,
            corporateBonds: BalancesConstants.zeroBalance,
            municipalBonds: BalancesConstants.zeroBalance,
            governmentBonds: BalancesConstants.zeroBalance,
            dayTradingBuyingPower: BalancesConstants.zeroDataSet,
            dayTradeMarginableEquity: BalancesConstants.zeroBalance,
            dayTradingBuyingPowerPrevClose: BalancesConstants.zeroBalance,
            dayTradeNonMarginableEquity: BalancesConstants.zeroBalance,
            dayTradeLongOptions: BalancesConstants.zeroBalance,
            dayTradeConvertibleBonds: BalancesConstants.zeroBalance,
            dayTradeCorporateBonds: BalancesConstants.zeroBalance,
            dayTradeMunicipalBonds: BalancesConstants.zeroBalance,
            dayTradeGovernmentBonds: BalancesConstants.zeroBalance,
            prevSMA: BalancesConstants.zeroBalance,
            taxReclaim: BalancesConstants.zeroBalance,
            totalFederalCallSMA: BalancesConstants.zeroDataSet,
            smaChange: BalancesConstants.zeroDataSet,
            houseCall: BalancesConstants.zeroDataSet,
            finraCall: BalancesConstants.zeroDataSet,
            foreignCCYHouseReq: BalancesConstants.zeroDataSet,
            totalHouseReq: BalancesConstants.zeroDataSet,
            totalFinraReq: BalancesConstants.zeroDataSet,
            debitInterestRate: BalancesConstants.zeroDataSet,
            optionHouseReq: BalancesConstants.zeroBalance,
            securityHouseReq: BalancesConstants.zeroBalance,
            cashAccountSurplusUsed: BalancesConstants.zeroBalance,
            minimumEquityReq: BalancesConstants.zeroBalance,
            whenIssuedHouseReq: BalancesConstants.NOT_APPLICABLE,
            foreignCCYList: [],
            cash: BalancesConstants.zeroDataSet,
            annuities: BalancesConstants.zeroDataSet,
            usdeCurrencyDetailList: [],
            localCurrencyDetailList: [],
            currencyDetailList: []
        },
        childBalances: [],
        accountSummary: undefined,
        asOfDate: undefined,
        quoteType: undefined
    };
}
